import React from 'react';
import { Checkbox, FormControl, Box, FormErrorMessage } from '@chakra-ui/react';
import { UseFormRegisterReturn } from 'react-hook-form';

interface AleaCheckboxProps {
  label: string;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  register: UseFormRegisterReturn;
  error?: string;
  // size: 'small' will render a compact variant; others behave as Chakra size
  size?: string;
  isDisabled?: boolean;
}

const AleaCheckbox: React.FC<AleaCheckboxProps> = ({
  label,
  isChecked,
  onChange,
  register,
  error,
  size,
  isDisabled = false,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.checked);
    register.onChange(e); // or register.onChange if you want to include all the default behavior of register
  };

  const isSmall = size === 'small';
  const chakraSize = isSmall ? 'sm' : size;
  const checkedIconSize = isSmall ? '12px' : '1.4rem';
  const labelFontSize = isSmall ? '16px' : '18px';

  return (
    <FormControl display="flex" alignItems="center" isInvalid={!!error}>
      <Checkbox
        isChecked={isChecked}
        onChange={handleChange}
        colorScheme="alea"
        size={chakraSize}
        isDisabled={isDisabled}
        _checked={{
          '& .chakra-checkbox__control svg': { width: checkedIconSize, height: checkedIconSize },
        }}
        sx={isSmall ? { '.chakra-checkbox__control': { width: '15px', height: '15px' } } : undefined}
        ref={register.ref}
        name={register.name}
        onBlur={register.onBlur}
      >
        <Box as="span" ml={isSmall ? '2px' : '4px'} fontSize={labelFontSize} fontWeight="normal">
          {label}
        </Box>
      </Checkbox>
      {error && <FormErrorMessage>{error}</FormErrorMessage>}
    </FormControl>
  );
};

export default AleaCheckbox;
